var _g, _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoTemplates = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 70,
  height: 74,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#no_templates_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 38.125,
  height: 42.125,
  x: 15.49,
  y: 12.217,
  fill: "url(#no_templates_svg__b)",
  rx: 3.6
}), /*#__PURE__*/React.createElement("rect", {
  width: 40.525,
  height: 44.525,
  x: 14.29,
  y: 11.017,
  stroke: "#fff",
  strokeWidth: 2.4,
  rx: 4.801
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 15.25,
  height: 17.75,
  x: 29.5,
  y: 21.907,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  rx: 2.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 15.25,
  height: 17.75,
  x: 24.5,
  y: 26.907,
  fill: "url(#no_templates_svg__c)",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  rx: 2.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#867AF2",
  strokeLinecap: "round",
  strokeWidth: 2.619,
  d: "m30.134 33.79 3.981 3.982M34.116 33.79l-3.982 3.982"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "no_templates_svg__b",
  x1: 15.49,
  x2: 53.615,
  y1: 33.28,
  y2: 33.28,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5DBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EDFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "no_templates_svg__c",
  x1: 24.5,
  x2: 39.75,
  y1: 35.782,
  y2: 35.782,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5DBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EDFF"
})), /*#__PURE__*/React.createElement("filter", {
  id: "no_templates_svg__a",
  width: 69.105,
  height: 73.105,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.272
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6.545
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0.0352941 0 0 0 0 0.509804 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_25_1069"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_25_1069",
  result: "shape"
})))));
export default SvgNoTemplates;